jQuery(document).ready(function ($) {
  if (!$('.post-card__modal-trigger').length) return;

  const $body = $('body');
  let $lastTrigger = null;

  function openModal($modal) {
    $modal.removeAttr('hidden');
    $('.post-type-modal__overlay').removeAttr('hidden');
    requestAnimationFrame(function () {
      $modal.addClass('is-active');
      $('.post-type-modal__overlay').addClass('is-active');
    });
    $body.addClass('modal-open');
    $modal.find('.post-type-modal__close').trigger('focus');
  }

  function closeAll(immediate) {
    const $modal = $('.post-type-modal.is-active');
    const $overlay = $('.post-type-modal__overlay');
    $modal.removeClass('is-active');
    $overlay.removeClass('is-active');

    if (immediate) {
      $modal.off('transitionend').attr('hidden', '');
      $overlay.off('transitionend').attr('hidden', '');
    } else {
      $modal.one('transitionend', function () {
        $(this).attr('hidden', '');
      });
      $overlay.one('transitionend', function () {
        $(this).attr('hidden', '');
      });
    }

    $body.removeClass('modal-open');

    if ($lastTrigger) {
      $lastTrigger.trigger('focus');
      $lastTrigger = null;
    }
  }

  $(document).on('click', '.post-card__modal-trigger', function () {
    const $modal = $('#' + $(this).data('modal'));
    if ($modal.length) {
      $lastTrigger = $(this);
      closeAll(true);
      openModal($modal);
    }
  });

  // Close button
  $(document).on('click', '.post-type-modal__close', function () {
    closeAll();
  });

  // Click outside modal inner
  $(document).on('click', '.post-type-modal', function (e) {
    if ($(e.target).is('.post-type-modal')) {
      closeAll();
    }
  });

  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && $('.post-type-modal.is-active').length) {
      closeAll();
    }
  });
});